module.exports = __webpack_public_path__ + "img/Icon-Prifile-Circle.d2ad835e.svg";